import { getClassroomApiUrl } from "@/js/utils/getBackendUrl";
import * as clsApi from "@/js/api/classroomApi";

export type StudentClaim = {
	studentId: string; // QID of the student.
	studentName: string; // First and last name of the student.
	studentUsername: string; // Username of the student.
	classId: string; // stableID of the class.
	className: string; // Name of the class.
	teacherId: string; // QID of the teacher.
	teacherName: string; // First and last name of the teacher.
	teacherEmail: string; // Email of the teacher.
	teacherUsername: string; // Username of the teacher.
	releasable: boolean; // Whether this claim can be released or not
};

export type StudentClaimsResponse = {
	studentClaims: StudentClaim[];
};

export type StudentClaimsRequest = {
	students: string[]; // QIDs of the students to claim.
};

export async function getStudentClaims(
	classroomId: string, // stableID for classroom or group.
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<StudentClaimsResponse> {
	const response = await fetch(
		`${host}/v1/appliances/${encodeURIComponent(authHeaders.Device)}/classrooms/${encodeURIComponent(classroomId)}/student-claims`,
		{
			method: "GET",
			headers: {
				...authHeaders,
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to fetch student claims: ${response.status}`);
	}

	return (await response.json()) as StudentClaimsResponse;
}

export async function postStudentClaims(
	classroomId: string, // stableID for classroom or group.
	payload: StudentClaimsRequest,
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(
		`${host}/v1/appliances/${encodeURIComponent(authHeaders.Device)}/classrooms/${encodeURIComponent(classroomId)}/student-claims`,
		{
			method: "POST",
			headers: {
				...authHeaders,
			},
			body: JSON.stringify(payload),
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to post student claims: ${response.status}`);
	}

	return;
}

export async function releaseStudentClaim(
	classroomId: string, // stableID for classroom or group.
	studentId: string, // student user QID
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(
		`${host}/v1/appliances/${encodeURIComponent(authHeaders.Device)}/classrooms/${encodeURIComponent(classroomId)}/student-claims/${encodeURIComponent(studentId)}/release`,
		{
			method: "POST",
			headers: {
				...authHeaders,
			},
		}
	);

	if (!response.ok) {
		throw new Error(`Failed to release student from claim: ${response.status}`);
	}

	return;
}
